import { useEffect, useState } from 'react';
import { api, darf, datum, zeitpunkt, type Anmelder }
  from '../api.ts';
import { Kopf, Karte, Kachel, Leer } from '../teile/Geruest.tsx';
import {
  Dialog, Fehlerkasten, Text, ausFehler, type Fehlerlage,
} from '../teile/Formular.tsx';
import Rotberichtigung from './Rotberichtigung.tsx';
import { useFrisch } from '../teile/Frisch.tsx';

/**
 * Welche Abgaben sind fällig, welche stehen schon.
 *
 * ORIGINALTEXT MARVIN (26.08.2026)
 *   „was ist mit den rotberichtigungen generieren automatisch und manuell?"
 *
 * BEIDES GAB ES, UND KEINES WAR ZU FINDEN. Der Lauf „rb_automatik" baute jeden
 * Werktag um neun, was dran ist, und schickt das Ergebnis nach Telegram. Der
 * Handweg stand als Dialog im Klappmenü der Auftragsakte. Was fehlte, war
 * DIESE Liste: die Frage „wer ist dran" liess sich nur beantworten, indem man
 * die Meldung von heute Morgen aufhob, und die lässt sich nicht anklicken.
 *
 * Das Modul stand bis zum 26.08.2026 auf `im_menue = false`, mit der
 * Begründung, die Rotberichtigung gehöre in die Akte. Das stimmt für den EINEN
 * Auftrag. Für „welche Abgaben sind fällig" stimmt es nicht.
 *
 * DIE ZAHLEN KOMMEN AUS DERSELBEN ABFRAGE WIE DAS BAUEN. Zwei Abfragen über
 * dieselbe Frage laufen auseinander, sobald jemand eine Bedingung nur an
 * einer Stelle nachzieht - und dann zeigt die Liste etwas anderes an, als
 * wirklich passiert.
 *
 * UND SEIT DEM 01.09.2026 GIBT ES DEN NÄCHTLICHEN LAUF NICHT MEHR
 * (Migration 098).
 *
 * ORIGINALTEXT MARVIN
 *   „warum sprichst du hier wieder von einem script, in dem fall
 *    „rb_automatik". die scripte gibt es nicht mehr und er soll die dateien
 *    sofort und just in time erzeugen."
 *
 * Die Mappe entsteht in dem Moment, in dem die Abgabe fällig wird: beim
 * Abhaken des letzten Gewerks (`routen/fertig.ts`) und beim Abschliessen
 * einer Dokumentation (`routen/doku.ts`). **Diese Liste ist damit keine
 * Vorschau mehr auf die Nacht, sondern eine Liste dessen, was LIEGENGEBLIEBEN
 * ist** - und jede Zeile sagt, warum.
 */

export default function Rotberichtigungen({
  ich, oeffne,
}: {
  ich: Anmelder;
  oeffne: (id: string, reiter?: string) => void;
}) {
  const [d, setD] = useState<any>(null);
  const [zeigen, setZeigen] = useState<'faellig' | 'gebaut' | 'alle'>('faellig');
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const [dialog, setDialog] = useState<string | null>(null);
  const [ruecknahme, setRuecknahme] = useState<any>(null);
  const darfBauen = darf(ich, 'aufmass.rotberichtigung');

  async function laden() {
    try { setD(await api.rbListe(zeigen)); setFehler(null); }
    catch (f) { setFehler(ausFehler(f)); }
  }
  useEffect(() => { laden(); }, [zeigen]);
  useFrisch(laden);

  if (fehler && !d) {
    return <div className="inhalt"><Fehlerkasten lage={fehler} /></div>;
  }
  if (!d) return null;

  return (
    <>
      <Kopf titel="Rotberichtigung"
            weg="Die Nachweismappe der Abgabe, je Auftrag" />
      <div className="inhalt">
        <Fehlerkasten lage={fehler} />

        <div className="kachelreihe">
          <Kachel wert={d.zahlen.faellig} was="Abgabe fällig"
                  farbe={d.zahlen.faellig ? 'var(--neu)' : undefined} />
          <Kachel wert={d.zahlen.gebaut} was="Mappe liegt vor" />
          <Kachel wert={d.zahlen.wartet} was="wartet noch auf ein Gewerk" />
          <Kachel wert={d.zahlen.angesehen} was="Aufträge angesehen" />
        </div>

        {d.deckel && (
          <div className="hinweis warnung">
            Es wurden nur die ersten {d.zahlen.angesehen} Aufträge angesehen.
            Es sind mehr.
          </div>
        )}

        <div className="reihe" style={{ margin: '14px 0' }}>
          {([['faellig', `fällig (${d.zahlen.faellig})`],
             ['gebaut', `schon gebaut (${d.zahlen.gebaut})`],
             ['alle', 'beides']] as const).map(([z, t]) => (
            <button key={z}
                    className={'knopf filter' + (zeigen === z ? ' gewaehlt' : '')}
                    onClick={() => setZeigen(z as any)}>
              {t}
            </button>
          ))}
        </div>

        <Karte titel={zeigen === 'gebaut' ? 'Erzeugte Mappen'
                    : zeigen === 'alle' ? 'Fällig und erzeugt'
                    : 'Noch offen'}>
          {!d.zeilen.length ? (
            <Leer text={zeigen === 'faellig'
              ? 'Keine Abgabe offen. Was fällig wird, entsteht sofort.'
              : 'Noch keine Mappe erzeugt.'} />
          ) : (
            <table className="liste">
              <thead>
                <tr>
                  <th>Baustelle</th>
                  <th style={{ width: 150 }}>Variante</th>
                  <th style={{ width: 260 }}>Warum</th>
                  <th style={{ width: 170 }}>schon gebaut</th>
                  <th style={{ width: 230 }}></th>
                </tr>
              </thead>
              <tbody>
                {d.zeilen.map((z: any) => (
                  <tr key={z.id} style={{ cursor: 'default' }}>
                    <td>
                      <button className="alslink" onClick={() => oeffne(z.id)}>
                        {z.strasse} {z.hausnummer}{z.hausnummer_zusatz ?? ''}
                      </button>
                      {/* DIE ANSCHRIFT MIT POSTLEITZAHL.
                          ORIGINALTEXT MARVIN (01.09.2026): „die kundenanschift
                          muss mit PLZ hin." Hier stand nur der Ort - und
                          „Berg" gibt es in Rheinland-Pfalz mehrfach. Wer eine
                          Baustelle sucht, sucht sie über die Postleitzahl. */}
                      <div className="leise klein">
                        {z.plz ? `${z.plz} ` : ''}{z.ort_text}
                        {z.kls_id && <>, KLS {z.kls_id}</>}
                      </div>
                    </td>
                    <td className="klein">
                      {/* EIN CHIP, DER SEINEN ZUSTAND TRÄGT.
                          ORIGINALTEXT MARVIN (01.09.2026): „die daten können
                          alle in einem grünen chip sein zur besseren
                          erkennbarkeit."
                          Hier stand für eine erzeugte Mappe `z-laufend` -
                          dieselbe blasse Farbe wie für „läuft gerade". Eine
                          fertige Abgabe ist eine GUTE Nachricht und darf so
                          aussehen; dieselbe Lehre wie beim erledigten Gewerk
                          am 31.08.2026. Drei Zustände, nicht zwei: grün heisst
                          „liegt vor", orange „noch offen", blau „wartet". */}
                      <span className={'marke-zustand '
                        + (z.schon ? 'z-erledigt'
                           : z.faellig ? 'z-neu' : 'z-laufend')}>
                        {z.art_text}
                      </span>
                      {z.gewuenscht && (
                        <div className="leise klein" style={{ marginTop: 3 }}>
                          ausdrücklich gewählt
                        </div>
                      )}
                    </td>
                    <td className="klein leise">{z.grund}</td>
                    <td className="klein">
                      {z.schon ? (
                        <>
                          {z.schon_datei_id ? (
                            <a href={api.dateiAdresse(z.schon_datei_id, z.schon_dateiname)}
                               target="_blank" rel="noreferrer">
                              {z.schon_dateiname}
                            </a>
                          ) : z.schon_dateiname}
                          <div className="leise klein">
                            {zeitpunkt(z.schon_am)}
                          </div>
                        </>
                      ) : <span className="leise">noch nicht</span>}
                    </td>
                    <td>
                      <div className="reihe">
                        {darfBauen && (
                          <button className="knopf klein"
                                  onClick={() => setDialog(z.id)}>
                            zusammenstellen
                          </button>
                        )}
                        {darfBauen && z.schon && (
                          <button className="knopf klein"
                                  onClick={() => setRuecknahme(z)}>
                            zurückziehen
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {/* HIER STAND EIN SKRIPTNAME UND EINE UHRZEIT.
              ORIGINALTEXT MARVIN (01.09.2026): „warum sprichst du hier wieder
              von einem script, in dem fall „rb_automatik". die scripte gibt es
              nicht mehr und er soll die dateien sofort und just in time
              erzeugen."
              Er hat recht, und es war mehr als ein Name: der Innendienst hakte
              um 14:30 das letzte Gewerk ab, und die Mappe entstand am nächsten
              Morgen. Seit Migration 098 entsteht sie in dem Moment, in dem sie
              fällig wird. */}
          <p className="klein leise" style={{ marginTop: 10, marginBottom: 0 }}>
            Eine Abgabe entsteht sofort, sobald sie fällig wird: beim Abhaken
            des letzten Gewerks und beim Abschliessen einer Dokumentation. Was
            hier unter „offen" steht, ist liegengeblieben - der Grund steht in
            der Zeile. Ein Teilaufmaß wird nie von allein vorgeschlagen; es
            braucht die ausdrückliche Wahl im Fenster.
          </p>
        </Karte>
      </div>

      {dialog && (
        <Rotberichtigung ich={ich} auftragId={dialog}
                         zu={() => setDialog(null)}
                         fertig={() => { setDialog(null); laden(); }} />
      )}
      {ruecknahme && (
        <Ruecknahme zeile={ruecknahme} zu={() => setRuecknahme(null)}
                    fertig={() => { setRuecknahme(null); laden(); }} />
      )}
    </>
  );
}


/**
 * Eine Mappe zurückziehen.
 *
 * ZURÜCKZIEHEN IST KEIN LÖSCHEN. Die Datei bleibt liegen, die Zeile bleibt
 * stehen und trägt ab jetzt Datum, Person und Grund. Wer feststellt, dass zu
 * viel in der Abgabe steht, will sie genau dann NICHT neu bauen, sondern erst
 * die Ordner richtigstellen - und bis dahin soll nichts als gültig gelten,
 * was es nicht ist.
 */
function Ruecknahme({
  zeile, zu, fertig,
}: { zeile: any; zu: () => void; fertig: () => void }) {
  const [grund, setGrund] = useState('');
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState<Fehlerlage | null>(null);
  const [rb, setRb] = useState<any>(null);

  // Die Kennung der gültigen Mappe steht nicht in der Liste, nur die der
  // Datei. Sie kommt aus der Vorschau desselben Auftrags.
  useEffect(() => {
    api.rb(zeile.id)
      .then((r) => setRb(r.frueher?.find((f: any) => !f.ersetzt_am) ?? null))
      .catch((f) => setFehler(ausFehler(f)));
  }, [zeile.id]);

  async function tu() {
    if (!rb) return;
    setLaeuft(true); setFehler(null);
    try { await api.rbZurueckziehen(rb.id, grund); fertig(); }
    catch (f) { setFehler(ausFehler(f)); }
    finally { setLaeuft(false); }
  }

  return (
    <Dialog titel="Rotberichtigung zurückziehen"
            untertitel={`${zeile.strasse} ${zeile.hausnummer}, ${zeile.ort_text}`}
            breite={560} laeuft={laeuft} zu={zu}>
      <Fehlerkasten lage={fehler} />
      <p className="klein">
        Die Datei bleibt liegen und bleibt lesbar. Sie gilt danach nicht mehr
        als gültige Abgabe, und sie wird beim nächsten fälligen Schritt neu
        gebaut.
      </p>
      {rb && (
        <p className="klein leise">
          Betroffen: {rb.dateiname} vom {datum(rb.erstellt_am)}
        </p>
      )}
      <Text name="grund" titel="Warum" pflicht mehrzeilig wert={grund}
            fehler={fehler} setze={setGrund}
            hinweis="Mindestens 5 Zeichen. Ohne Grund ist die Rücknahme in
                     einem Monat nicht mehr zu erklären." />
      <div className="reihe">
        <button className="knopf haupt"
                disabled={laeuft || !rb || grund.trim().length < 5}
                onClick={tu}>
          zurückziehen
        </button>
        <button className="knopf" disabled={laeuft} onClick={zu}>Abbrechen</button>
      </div>
    </Dialog>
  );
}
